import Vue from 'vue'
import App from '../App.vue';
import Router from 'vue-router'
import login from '@/components/login'//登陆
import indexMa from '@/components/MA/indexMa'//首页
import addClinic from '@/components/MA/clinicManagement/addClinic'//添加诊所
import clinicProbate from '@/components/MA/clinicManagement/clinicProbate'//诊所认证
import clinicManagement from '@/components/MA/clinicManagement/clinicManagement'//诊所管理
import doctorProbate from '@/components/MA/accountManagement/doctorProbate'//医护人员认证
import doctorList from '@/components/MA/accountManagement/doctorList'//医护人员认证
import doctorExpert from '@/components/MA/accountManagement/doctorExpert'//专家团队管理

import userOverview from '@/components/MA/dateA/userOverview.vue'//用户总览
import desktopExe from '@/components/MA/dateA/desktopExe.vue'//用户总览
import vCard from '@/components/MA/dateA/vCard.vue'//用户总览
import coupon from '@/components/MA/operationManagement/coupon.vue'//优惠卷
import sharingCommunity from '@/components/MA/operationManagement/sharingCommunity.vue'//优惠卷
Vue.use(Router)

export default new Router({
  routes: [
    //登陆
    {
      path: '/',
      name: 'login',
      component: login,
      
    },
    //Ma
	  {
			path: '/indexMa',
		  name: 'indexMa',
		  component: indexMa,
		  children:[{
		  	//添加团队
		    	path: '/indexMa/addClinic',
		      name: 'addClinic',
		      component: addClinic
		    },
		    //诊所认证
		    {
		    	path: '/indexMa/clinicProbate',
		      name: 'clinicProbate',
		      component: clinicProbate
		    },
		   //诊所认证
		    {
		    	path: '/indexMa/clinicManagement',
		      name: 'clinicManagement',
		      component: clinicManagement
		    },
		  	 //医护人员认证
		    {
		    	path: '/indexMa/doctorProbate',
		      name: 'doctorProbate',
		      component: doctorProbate
		    },
		  	{
		    	path: '/indexMa/doctorList',
		      name: 'doctorList',
		      component: doctorList
		    },
		    {
		    	path: '/indexMa/doctorExpert',
		      name: 'doctorExpert',
		      component: doctorExpert
		    },
		  	{
		    	path: '/indexMa/userOverview',
		      name: 'userOverview',
		      component: userOverview
		    },{
		    	path: '/indexMa/desktopExe',
		      name: 'desktopExe',
		      component: desktopExe
		    },{
		    	path: '/indexMa/vCard',
		      name: 'vCard',
		      component: vCard
		    },{
		    	path: '/indexMa/coupon',
		      name: 'coupon',
		      component: coupon
		    },{
		    	path: '/indexMa/sharingCommunity',
		      name: 'sharingCommunity',
		      component: sharingCommunity
		    },]
	  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js